<div class="rcp-flex rcp-justify-between rcp-border-b rcp-border-ul-gray-350">
    <div class="rcp-flex rcp-items-center rcp-gap-2">
        <img
            src="assets/images/ul-logo.svg"
            alt="UL Logo"
            class="rcp-ml-[12px] rcp-w-32 rcp-pb-[10px] rcp-pt-[10px]"
        />
    </div>
    @if (!isMF()) {
        <div class="rcp-flex rcp-items-center rcp-gap-2">
            <div
                class="rcp-mr-4 rcp-inline-flex rcp-h-[40px] rcp-w-[40px] rcp-cursor-pointer rcp-items-center rcp-justify-center rcp-rounded-full rcp-bg-ul-red-400 rcp-font-poppins rcp-text-xl rcp-text-white"
                matTooltip="{{ userDetails() }}"
                (click)="onLogoutClicked($event)"
            >
                {{ userFullNameInitials() }}
            </div>
        </div>
    }
</div>
